__turbopack_context__.v({
  "container": "gbXkaG_container",
  "isHover": "gbXkaG_isHover",
  "isSelected": "gbXkaG_isSelected",
  "tooltip": "gbXkaG_tooltip",
  "value": "gbXkaG_value",
});
